// Internal Imports
import { API_ENDPOINTS } from "../../constants";
import { post, get } from "../../api/index";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const authEmailVerificationService = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTH}/trigger-verify`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `authService => authEmailVerificationService => ${error}`,
        );
        reject(error);
      });
  });

export const authorizeRevvApiClients = searchQuery =>
  new Promise((resolve, reject) => {
    get(`${APIS.OAUTH_CONSENT}${searchQuery}`)
      .then(response => {
        resolve((response && response.redirect_url) || "");
      })
      .catch(error => {
        console.error(`authService => authorizeRevvApiClients => ${error}`);
        reject(error);
      });
  });
